import React from "react";
import { getTranslations } from "../../Common/utils";
import TrackerCheckboardFlag from "../Cloudinary/TrackerCheckboardFlag";
import TrackerHelmet from "../Cloudinary/TrackerHelmet";
import TrackerPodium from "../Cloudinary/TrackerPodium";

const Rank = ({ rank, isMyRank }) => {
  return (
    <div className="si-tracker__card-rank">
      {isMyRank
        ? getTranslations("eot_my_rank_label", "My Rank")
        : getTranslations("eot_tracker_rank_lbl", "Rank")}
      : <span>{rank}</span>
    </div>
  );
};

const TrackerImage = ({ imageName }) => {
  switch (imageName) {
    case "checkboard-flag":
      return <TrackerCheckboardFlag />;
    case "helmet":
      return <TrackerHelmet />;
    case "podium":
      return <TrackerPodium />;
    default:
      return null;
  }
};

const TrackerCard = ({
  extraCls,
  isIconName,
  trkCrdTitle,
  trkCrdCaption,
  trkCrdUserRank,
  trkCrdComponentBottom,
  trkCrdComponentRight,
  isMyRank = false,
}) => {
  return (
    <>
      <div
        className={`si-tracker__card ${
          extraCls ? `si-tracker__card--${extraCls}` : ""
        }`}
      >
        <div className="si-tracker__card-top">
          <div className="si-tracker__card-topGrid">
            <h2 className="si-tracker__card-title">
              {isIconName ? (
                <div className="si-tracker__card-icon">
                  <TrackerImage imageName={isIconName} />
                </div>
              ) : null}
              <span>{trkCrdTitle}</span>
            </h2>
            {trkCrdComponentRight && (
              <Rank rank={trkCrdUserRank} isMyRank={isMyRank} />
            )}
          </div>
        </div>
        <div className="si-tracker__card-bot">
          <h3 className="si-tracker__card-caption">{trkCrdCaption}</h3>
          {trkCrdComponentBottom && (
            <Rank rank={trkCrdUserRank} isMyRank={isMyRank} />
          )}
        </div>
      </div>
    </>
  );
};

export { TrackerCard };
